module.exports = __webpack_public_path__ + "img/dynamic-28 - 副本.19adf57f.png";